import React, { useEffect } from 'react';
import { useIntl } from '../../../../util/reactIntl';
import { IconClose } from '../../../../components';
import css from './WatchDemoModal.module.css';

const YOUTUBE_EMBED_EN = 'https://www.youtube.com/embed/Wvli8-9m4rY?autoplay=1';
const YOUTUBE_EMBED_AR = 'https://www.youtube.com/embed/ibcpbvY0X-o?autoplay=1';

const WatchDemoModal = ({ isOpen, onClose }) => {
  const intl = useIntl();
  const arabicLanguage =
    typeof window !== 'undefined' && localStorage.getItem('language') === 'Arabic';
  const embedSrc = arabicLanguage ? YOUTUBE_EMBED_AR : YOUTUBE_EMBED_EN;

  useEffect(() => {
    if (!isOpen) return undefined;
    const onKeyUp = e => {
      if (e.key === 'Escape') onClose();
    };
    document.body.addEventListener('keyup', onKeyUp);
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.removeEventListener('keyup', onKeyUp);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className={css.overlay}
      role="dialog"
      aria-modal="true"
      aria-labelledby="watch-demo-title"
      onClick={onClose}
    >
      <div className={css.dialog} onClick={e => e.stopPropagation()}>
        <button type="button" className={css.closeButton} onClick={onClose} aria-label="Close">
          <IconClose />
        </button>
        <h2 id="watch-demo-title" className={css.srOnly}>
          {intl.formatMessage({ id: 'ForBusiness.demoModalTitle' })}
        </h2>
        <p className={css.srOnly}>
          {intl.formatMessage({ id: 'ForBusiness.demoModalDescription' })}
        </p>
        <div className={css.videoWrap}>
          <iframe
            className={css.iframe}
            src={embedSrc}
            title={intl.formatMessage({ id: 'ForBusiness.demoModalTitle' })}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        </div>
      </div>
    </div>
  );
};

export default WatchDemoModal;
